<template>
	<AppScreen :scrollable="false">
		<div class="intro-wrapper">
			<li class="intro-slide" v-for="slide in currentSlideArray" :key="slide.id">
				<Host />
				<div class="wysiwyg-content" v-html="slide.content" />
				<MarqueeButton :action="playGame" v-if="currentIndex === maxIndex">
					{{ slides[maxIndex].button_text }}
				</MarqueeButton>
			</li>
			<div class="btn-wrapper">
				<transition name="fade">
					<Button class="view-next-btn" :action="next" v-if="!isLastSlide" />
				</transition>
				<transition name="fade">
					<Button class="view-previous-btn" :action="previous" v-if="currentIndex > 0" />
				</transition>
			</div>
		</div>
	</AppScreen>
</template>

<script>
// There's a really weird error on ios here, where if the order of the buttons is changed
// to be previous _then_ next, the v-if on the next button fails to register properly?

import { mapState } from 'vuex';
import carouselMixins from "@/mixins/carousel-slides";
import AppScreen from "@/components/partials/AppScreen";
import Button from "@/components/base/Button";
import Host from '@/components/base/Host';
import MarqueeButton from "@/components/base/MarqueeButton";

export default {
	name: "Intro",
	mixins: [carouselMixins],
	components: {
		AppScreen,
		Button,
		Host,
		MarqueeButton,
	},
	computed: {
		...mapState({
			slides: (state) => state.global.api.data.ui.intro.slides,
			labels: (state) => state.global.api.data.ui.intro.labels,
		}),
	},
	methods: {
		playGame() {
			this.$router.push("/game/start");
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
		},
	},
};
</script>

<style lang="scss" scoped>
	.intro-wrapper {
		@include swirl-background;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		padding: 0 20px;
	}

	.host-component {
		margin: 30px 0;

		@include desktop {
			min-height: 300px;
			max-height: 450px;
		}

		@include desktop-lg { max-height: 600px; }
	}

	.intro-slide {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-height: 500px;
	}

	.host-component { margin: 20px 0; }

	.wysiwyg-content {
		width: 80%;
		text-align: center;
	}

	.btn-wrapper {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
		pointer-events: none;

		@include mobile {
			top: unset;
			height: 100px;
		}
	}

	.view-previous-btn,
	.view-next-btn {
		position: absolute;
		margin: auto 0;
		top: 0;
		bottom: 0;
		pointer-events: all;
		z-index: $z-top;
	}

	.view-next-btn { right: 0; }
	.view-previous-btn { left: 0; }

	.marquee-btn { margin: 0; }
</style>
